import { useEffect, useState } from "react"
import { FiSearch } from "react-icons/fi"
import { userSearchSlugGenerator } from "@/utils/slugGenerator"
interface ComponentProps {
    setSearchedClinics: any,
    clinicList: any
}

export default function SearchClinics({ setSearchedClinics, clinicList }: ComponentProps) {

    const [userSearchData, setUserSearchData] = useState("")

    function gatherData(e: React.ChangeEvent<HTMLInputElement>) {
        setUserSearchData(userSearchSlugGenerator(e.target.value))
    }

    useEffect(() => {
        if (userSearchData.trim().length > 0) {
            const results = clinicList.filter((clinic: any) => clinic.slug?.includes(userSearchData))
            setSearchedClinics([...results])
        } else {
            setSearchedClinics([])
        }
    }, [userSearchData])

    return (
        <div className="w-full mb-5">
            <div className="w-full">
                <div className="flex flex-col lg:flex-row items-center justify-start gap-3 w-full">

                    <div className="relative w-full lg:flex-1 ">
                        <label className="block text-xs font-medium text-pink-500 mb-1 ml-1">
                            Klinik
                        </label>
                        <input
                            defaultValue={userSearchData}
                            onChange={(e) => gatherData(e)}
                            type="text"
                            placeholder={"Klinik ara..."}
                            className={` 
                            w-full 
                            rounded-md  
                            border  
                          border-pink-500 animate-pulse
                            bg-white  
                            py-2.5 pl-10 pr-12 
                            text-sm  
                            text-gray-700 
                            placeholder-gray-400 
                            shadow-sm 
                            focus:border-pink-bg 
                            focus:ring-2 
                            focus:ring-pink-bg 
                            focus:outline-none
                            `}
                        />

                        <FiSearch className="absolute left-3 bottom-2.5 h-5 w-5 text-gray-400" />

                    </div>
                </div>
            </div>
        </div>



    )

}